import { solutions } from "./solutions";
import { softwareItems } from "./software";

export const solutionNavItems = solutions.map(({ title, slug }) => ({
    label: title,
    path: `/solutions/${slug}`,
}));

export const softwareNavItems = softwareItems.map(({ title, slug }) => ({
    label: title,
    path: `/software/${slug}`,
}));
